import React, { useContext, useEffect, useState } from "react";
import { Col, Button, InputGroup, Form } from "react-bootstrap";
import blogFetch from "../../../axios/config";
import '../styles.css'
import { ReasonModal } from "../../wagonApproved/components/ReasonModal";
import Dropdown from 'react-bootstrap/Dropdown';
import Context from "../../../context/Context";
import Loading from "../../../components/Loading";


const TIPO_APONT = [
  "REPROCESSO",
  "APROVADO",
  "REFUGO"
]

export const TableWagonToAnalyze = () => {

  const [vagoesAnalise, setVagoesAnalise] = useState([])
  const [showReason, setShowReason] = useState(false)
  const [apontamentoStatus, setApontamentoStatus] = useState({})
  const [clickedItem, setClickedItem] = useState()
  const [selectedTipoApont, setSelectedTipoApont] = useState("")
  const [index, setIndex] = useState()

  const [piecesToAnalyze, setPiecesToAnalyze] = useState([])
  const [searchPieces, setSearchPieces] = useState("");

  const {
    selectedFurnace,
    loading,
    setLoading
  } = useContext(Context);

  useEffect(() => {
    getVagoesAnalise()
  }, [])

  const FormatVagaoKey = (clickedItem) => {
    return parseInt(clickedItem.vagoes_Fornos.vagao_Serial.replace(/0+(\d+)/g, '$1').substring(1))
  }

  const filteredvagoesAnalise = vagoesAnalise.filter(
    ({ ordem_Serial, vagoes_Fornos }) =>
      ordem_Serial.toString().toLowerCase().includes(searchPieces.toLowerCase()) ||
      vagoes_Fornos.vagao_Serial.toString().toLowerCase().includes(searchPieces.toLowerCase())
  );

  const handleStatusChange = (index, status) => {
    setApontamentoStatus((prevStatus) => ({
      ...prevStatus,
      [index]: status,
    }));
  };

  const resetIndex = (index) => {
    setApontamentoStatus(prevStatus => {
      const { [String(index)]: removed, ...rest } = prevStatus;
      let newStatus = {};
      let i = 0;
      for (let key in rest) {
        newStatus[String(i)] = rest[key];
        i++;
      }
      return newStatus;
    });
  }

  const handleApontarClick = async (index) => {
    setLoading(true)
    const status = apontamentoStatus[index];
    setSelectedTipoApont(status || "TIPO APONTAMENTO");
    setClickedItem(vagoesAnalise[index]);

    try {
      if (status === "APROVADO") {
        await postAprovadoApontamento(vagoesAnalise[index]);
        await putPeca(vagoesAnalise[index]);
        await putAprovadoVagao(vagoesAnalise[index])
        resetIndex(index)
      } else {
        setShowReason(true);
      }
    } catch (e) {
      console.error(e)
    } finally {
      await getVagoesAnalise()
      setLoading(false)
    }
  };

  const getUserMatricula = () => {
    const nro_matricula = JSON.parse(localStorage.getItem('user'))
    const userSAPMatricula = nro_matricula['user_SAPMatricula'];
    return userSAPMatricula
  }

  const getVagoesAnalise = async () => {
    try {
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornosPecas/analise`
      )
      setVagoesAnalise(data)
    } catch (error) {
      console.error(error)
    }
    finally {

    }
  }

  const putPeca = async (item) => {

    console.log(item);
    
    try {
      await blogFetch.put(`/ISAGA_VagoesFornosPecas`, {
        Vagao_Key: item.vagoes_Fornos.vagao_Key,
        Ordem_Serial: item.ordem_Serial,
        Status: "APROVADO",
        Molde_Key: item.molde_Key,
        Status_Peca: "APROVADO"
      });
    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  const postAprovadoApontamento = async (item) => {

    const userSAPMatricula = getUserMatricula();

    try {
      await blogFetch.post(`ISAGA_ApontamentoSAP?furnace=${selectedFurnace}`, {
        Centro_Trabalho: "06CURVAD",
        Ordem_Fabricacao: item.ordem_Serial,
        Operacao: "1000",
        Tipo_Apontamento: "APROVADO",
        Chave_Modelo: "SALH",
        Nro_Matricula: userSAPMatricula
      })
    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  const putAprovadoVagao = async () => {
    try {
      await blogFetch.put(`/ISAGA_VagoesFornos/aprovado`, {
        Vagao_Key: clickedItem.vagoes_Fornos.vagao_Key
      })

    } catch (e) {
      console.error(e)
    } finally {

    }
  }

  return (
    <>
      {vagoesAnalise.length > 0 ?
        <Col>
          {!loading ?
            <div>

              <h1 className="title_tables mt-2 mb-3">
                VAGÕES PARA ANÁLISAR
              </h1>

              <InputGroup className="mt-2 mb-3 w-25">
                <Form.Control
                  placeholder="Buscar Peça - Ordem Serial"
                  value={searchPieces}
                  onChange={({ target }) => setSearchPieces(target.value)}
                />
                <Button>
                  Buscar
                </Button>
              </InputGroup>

              <table className="tableFixHead table text-center">
                <thead>
                  <tr>
                    <th>ORDEM SERIAL</th>
                    <th>VAGÃO SERIAL</th>
                    <th>STATUS PEÇA</th>
                    <th>OBSERVACÂO</th>
                    <th>TIPO APONTAMENTO</th>
                    <th>APONTAR</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredvagoesAnalise.map((peca, index) => (
                    <tr key={index}>
                      <td> {peca.ordem_Serial} </td>
                      <td> {peca.vagoes_Fornos.vagao_Serial} </td>
                      <td> {peca.status_Peca} </td>
                      <td> {peca.observacao ? peca.observacao : "SEM OBSERVAÇÃO"} </td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle className="" id="dropdown-basic">
                            {apontamentoStatus[index] ? apontamentoStatus[index] : "TIPO APONTAMENTO"}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            {TIPO_APONT.map((item, itemIndex) => (
                              <Dropdown.Item
                                key={itemIndex}
                                onClick={() => handleStatusChange(index, item)}
                              >
                                {item}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                      <td>
                        <Button
                          onClick={() => {
                            handleApontarClick(index)
                            setIndex(index)
                            setClickedItem(peca)
                          }}
                          disabled={!apontamentoStatus[index]}
                          className="">
                          APONTAR
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            : (<Loading />)}

          <ReasonModal
            resetIndex={resetIndex}
            index={index}
            getVagoesAnalise={getVagoesAnalise}
            showReason={showReason}
            setShowReason={setShowReason}
            clickedItem={clickedItem}
            apontamentoStatus={selectedTipoApont}
            putAprovadoVagao={putAprovadoVagao}
          />

        </Col>
        : (<h1 className="title_tables">SEM PEÇAS PARA ANÁLISE</h1>)}
    </>
  )
}